import { KeyDocumentRow, KeyDocumentsProps } from '../components/blocks/KeyDocumentsBlock'
import { AliasedKeyDocumentsBlock } from '../components/PortableText/serializers/componentTypes/KeyDocumentsSerializer'
import { notEmpty } from '../utilities/filters'
import {
  filterSanityEmptyAttachments,
  mapSanityAttachmentToAttachment,
} from './ReportsMapper'

export const mapSanityKeyDocumentsProps = (
  {
    downloadsGaTrackingId,
    heading,
    preamble,
    rows,
    tableHeadings,
    tableRows,
  }: AliasedKeyDocumentsBlock,
  siteWideDisclaimerEnabledForThisPage: boolean
): KeyDocumentsProps => {
  const filteredRows: KeyDocumentRow[] = []

  const currentRows = rows ?? tableRows

  if (!!currentRows) {
    currentRows.filter(notEmpty).forEach(row => {
      const tableRow = {
        cells: row.cells ?? [],
        attachments:
          row.attachments
            ?.filter(notEmpty)
            .filter(filterSanityEmptyAttachments)
            .map(attachment =>
              mapSanityAttachmentToAttachment(
                attachment,
                siteWideDisclaimerEnabledForThisPage
              )
            ) ?? undefined,
        secondaryAttachments:
          row.secondaryAttachments
            ?.filter(notEmpty)
            .filter(filterSanityEmptyAttachments)
            .map(attachment =>
              mapSanityAttachmentToAttachment(
                attachment,
                siteWideDisclaimerEnabledForThisPage
              )
            ) ?? undefined,
      }

      filteredRows.push(tableRow)
    })
  }

  return {
    downloadsGaTrackingId: downloadsGaTrackingId ?? undefined,
    rows: filteredRows ?? [],
    tableHeadings: tableHeadings?.filter(notEmpty) ?? [],
    text: preamble ?? undefined,
    title: heading ?? undefined,
  }
}
